<h1 mat-dialog-title>
  {{ data.title }}
</h1>

<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>

<div mat-dialog-actions>
  <button
    *ngIf="(options.buttonLabels?.length ?? 0) > 1"
    mat-raised-button
    (click)="onDismiss()"
  >
    {{ options.buttonLabels && options.buttonLabels[1] }}
  </button>
  <button mat-raised-button color="primary" (click)="onConfirm()">
    {{ options.buttonLabels && options.buttonLabels[0] }}
  </button>
</div>
